import React, { useEffect, useState, useRef } from 'react';
import NotificationAlert from "react-notification-alert";
import axios from 'axios';
import Cookies from 'js-cookie';

import * as constants from 'constants/index.js';
import CardsHeader from 'layouts/Headers/CardsHeader.js';

import InputSideCustom from 'views/pages/components/InputSideCustom';
import {
  InputArraySideSelect,
} from 'views/pages/components/InputSelect';
import TableCustom from 'views/pages/components/TableCustom';

import {
  Container,
  Row,
  Col,
  Card,
  CardHeader,
  CardBody,
  Button,
} from 'reactstrap';

export default function ReportDeal() {
  const notificationAlert = useRef(null);

  const [token, setToken] = useState('');
  const [loading, setLoading] = useState(true);
  const [dealers, setDealers] = useState([]);
  const [filter, setFilter] = useState('');
  const [items, setItems]  = useState([]);
  const [totalAverageMonthIterative, setTotalAverageMonthIterative] = useState('');
  const [totalDeposit, setTotalDeposit] = useState('');
  const [totalIncome, setTotalIncome] = useState('');

  const notify = (type, header, message) => {
    let options = {
      place: "tc",
      message: (
        <div className="alert-text">
          <span className="alert-title" data-notify="title">
            {" "}
            {header}
          </span>
          <span data-notify="message">
            <div dangerouslySetInnerHTML={{ __html: message }} />
          </span>
        </div>
      ),
      type: type,
      icon: "ni ni-bell-55",
      autoDismiss: 5
    };
    notificationAlert.current.notificationAlert(options);
  };

  useEffect(() => {
    let grs_token = Cookies.get('grs_token')
    setToken(grs_token)

    const source = axios.CancelToken.source()
    fetchData(source, grs_token, '')

    return () => {
      source.cancel()
    };
  }, [])

  const fetchData = async (source, token, filter) => {
    try {
      const response = await axios({
        method: 'GET',
        url: constants.API_URL + '/report/deals',
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params: filter,
        cancelToken: source.token,
      })
      const data = response.data

      setLoading(true)
      setDealers(data.data.dealers)
      setFilter({
        ...data.data.filter,
        from: data.data.filter.from? constants.formatDate(data.data.filter.from): '',
        to: data.data.filter.to? constants.formatDate(data.data.filter.to): '',
      })
      setItems(data.data.items)
      setTotalAverageMonthIterative(data.data.totalAverageMonthIterative)
      setTotalDeposit(data.data.totalDeposit)
      setTotalIncome(data.data.totalIncome)

      setTimeout(() => {
        setLoading(false)
      }, 1000)
    } catch (error) {
      setLoading(false)
      if (axios.isCancel(error)) {
        console.log('Request canceled :: ', error)
      } else {
        console.error('error :: ', error)
        notify('warning', 'Warning', error.response ? error.response.statusText : 'Error occurred!')
      }
    }
  }

  const filterItems = () => {
    const source = axios.CancelToken.source()
    fetchData(source, token, {
      ...filter,
      from: constants.formatDate(filter.from),
      to: constants.formatDate(filter.to),
    })
  }

  const resetItems = () => {
    setFilter('')
    const source = axios.CancelToken.source()
    fetchData(source, token, '')
  }

  return (
    <>
      <CardsHeader name="Sales" parentName="Home" currentName="List" />
      <div className="rna-wrapper">
        <NotificationAlert ref={notificationAlert} />
      </div>
      <Container className="mt--5 admin-main-body" fluid >
        <Row>
          <Col xl="12">
            <Card>
              <CardHeader>
                <h1 className="title">Sales</h1>
                <p className="text-sm mb-0">Sales overview</p>
              </CardHeader>
              <CardBody>
                <Container>
                  <Row>
                    <Col md={6} sm={12}>
                      <InputSideCustom 
                        type={`date`}
                        label={`From`}
                        value={filter && filter.from? filter.from: ''}
                        onChange={e => setFilter({
                          ...filter,
                          from: e.target.value
                        })}
                      />
                    </Col>
                    <Col md={6} sm={12}>
                      <InputSideCustom 
                        type={`date`}
                        label={`To`}
                        value={filter && filter.to? filter.to: ''}
                        onChange={e => setFilter({
                          ...filter,
                          to: e.target.value
                        })}
                      />
                    </Col>
                    {filter.isAllowedToFilterByDealer && 
                    <Col md={6} sm={12}>
                      <InputArraySideSelect
                        label={`Offices`}
                        options={dealers}
                        value={filter && filter.office? filter.office: ''}
                        onChange={e => setFilter({
                          ...filter,
                          office: e.target.value
                        })}
                        valueKey={`id`}
                        labelKey={`name`}
                        defaultOption={true}
                      />
                    </Col>}
                  </Row>
                  <div className="d-flex flex-row justify-content-center">
                    <Button className="w-50" color="success" onClick={() => filterItems()}>Filter</Button>
                    <Button className="w-50" color="danger" onClick={() => resetItems()}>Reset</Button>
                  </div>
                </Container>
                <Row className="mt-4">
                  <Col xl={12} className="px-5">
                    <div className="d-flex flex-row justify-content-between flex-wrap">
                      <div className="p-2">
                        <h2 className="mb-0">{`Deposit`}</h2>
                        <h2 className="mb-0">{constants.CURRENCY} {totalDeposit}</h2>
                      </div>
                      <div className="p-2">
                        <h2 className="mb-0">{`Total Payment`}</h2>
                        <h2 className="mb-0">{constants.CURRENCY} {totalIncome}</h2>
                      </div>
                      <div className="p-2">
                        <h2 className="mb-0">{`Average Month Income`}</h2>
                        <h2 className="mb-0">{constants.CURRENCY} {totalAverageMonthIterative}</h2>
                      </div>
                      <div className="p-2">
                        <h2 className="mb-0">{`Project YTD Totals`}</h2>
                        <h2 className="mb-0">{constants.CURRENCY} {totalIncome}</h2>
                      </div>
                    </div>
                  </Col>
                </Row>
                <TableCustom 
                  loading={loading}
                  keyField={`id`}
                  searchField={false}
                  items={items}
                  columns={[
                    {
                      dataField: "dealer_name",
                      text: "Office",
                      sort: true
                    },
                    {
                      dataField: "date_delivered",
                      text: "Deal Date",
                      sort: true
                    },
                    {
                      dataField: "full_name",
                      text: "Name",
                      sort: true
                    },
                    {
                      dataField: "vehicle_monthly_settled_term",
                      text: "Term",
                      sort: true
                    },
                    {
                      dataField: "initial_payment",
                      text: "Deposit",
                      sort: true
                    },
                    {
                      dataField: "monthly_payment",
                      text: "Weekly Payment",
                      sort: true
                    },
                    {
                      dataField: "monthly_estimated_payment",
                      text: "Average Monthly Payment",
                      sort: true
                    },
                    {
                      dataField: "total_payment",
                      text: "Total Payment",
                      sort: true
                    },
                    {
                      dataField: "average_month_income_iterative",
                      text: "Average Month Income",
                      sort: true
                    },
                    {
                      dataField: "total_cost_iterative",
                      text: "Projected YTD Total",
                      sort: true
                    }
                  ]}
                />
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  )
}